export default {
  methods: {
    downloadFile(action, filter, openFileInBrowser = false) {
      return this.$store.dispatch(action, filter).then((response) => {
        // see also https://stackoverflow.com/questions/50736657/vue-laravel-how-to-properly-download-a-pdf-file

        const contentDispositionHeader = response.request.getResponseHeader('Content-Disposition');
        const contentTypeHeader = response.request.getResponseHeader('Content-Type');
        let filenameFromHeader = null;
        if (contentDispositionHeader) {
          const re = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const arrayOfMatches = contentDispositionHeader.match(re);
          filenameFromHeader = arrayOfMatches[0].replace('filename=', '');
        }

        const blob = new Blob([response.data], { type: contentTypeHeader });
        const fileUrl = window.URL.createObjectURL(blob);
        const fileLink = document.createElement('a');
        fileLink.href = fileUrl;
        fileLink.target = '_blank';

        if (!openFileInBrowser) fileLink.setAttribute('download', filenameFromHeader);


        document.body.appendChild(fileLink);
        fileLink.click();
      }, (error) => {
        console.error(`Failed to download file. <${error}>`);
      });
    },
  },
};
